import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-top: 3.42rem;
  // margin-left: 4.4rem;
  padding: 4rem 1.5rem 5rem 5.5rem;
  // border: 2px solid red;

  // esta aqui pq usa no começo da pagina e dentro das classificações
  .button-add-item {
    display: flex;
    margin: 0 20px;

    button {
      background-color: transparent;
      color: var(--azul-razio);
      font-weight: 600;
      border: 2px solid var(--azul-razio);
      border-radius: 8px;
      padding: 10px 20px;
    }
  }

  // 760px
  @media (max-width: 47.5rem) {
    padding: 4.5rem 1rem 5rem;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		padding: 4.5rem 0.5rem 5rem;
  }
`;

export const Header = styled.div`
  display: flex;
  // flex-direction: column;
	justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;

	.header-texts {
		h1 {
			font-size: 24px;
			font-weight: 500;
		}
		h2 {
			font-size: 20px;
			color: #607d8b;
		}
	}

	// 479px
  @media (max-width: 29.9375rem) {
		.header-texts {
			h1 {
				font-size: 18px;
			}
			h2 {
				font-size: 14px;
			}
		}
  }
`;

export const ButtonAddItemContent = styled.button`
	font-weight: bold;
	background-color: var(--azul-razio);
	color: #fff;
	// border: 0.125rem solid var(--azul-razio); // 0.0625rem = 1px; 0.125rem = 2px;
	padding: 0.3125rem 0.625rem; // 0.3125 = 5px; 0.625rem = 10px;
	border-radius: 0.625rem; //0.5rem = 8px; 0.625rem = 10px;
	width: 9rem;
	height: 3rem;

	// 479px
  @media (max-width: 29.9375rem) {
		width: 6rem;
		height: 2.3rem;
	}
`;